import { PlatformPlugin, PluginType, } from '@segment/analytics-react-native';
import { getUUID } from '@segment/analytics-react-native/src/uuid';
import { libraryInfo } from '@segment/analytics-react-native/src/info';
import { Dimensions, Platform } from 'react-native';
export class WebEnrichmentPlugin extends PlatformPlugin {
    config;
    type = PluginType.enrichment;
    webContext;
    constructor(config) {
        super();
        this.config = config;
        this.webContext = this.getWebContext();
    }
    execute(event) {
        if (this.webContext) {
            event.context = {
                ...this.webContext,
                ...event.context,
            };
        }
        return event;
    }
    getWebContext() {
        if (Platform.OS !== 'web') {
            return undefined;
        }
        const device = {
            name: Platform.OS,
            type: Platform.OS,
        };
        const intl = Intl?.DateTimeFormat()?.resolvedOptions() || {};
        const { width, height } = Dimensions.get('screen');
        return {
            app: {
                name: this.config.appName,
                version: this.config.appVersion,
            },
            device,
            library: {
                name: libraryInfo.name,
                version: libraryInfo.version,
            },
            locale: intl?.timeZone || navigator?.language,
            os: {
                name: navigator?.userAgentData?.platform,
            },
            screen: {
                width,
                height,
            },
            timezone: intl?.timeZone,
            instanceId: getUUID(),
        };
    }
}
//# sourceMappingURL=WebEnrichmentPlugin.js.map